import * as R from 'ramda'

export default R.pipe(R.split(/[ _)(-]+/g), R.map(R.pipe(R.trim, R.head)), R.join(''))
